import { createSlice } from '@reduxjs/toolkit';

const contactFilterSlice = createSlice({
    name: 'contactFilter',
    initialState: {
        isLoading: true,
        isError: false,
        error: false,
        getState: [],
    },
    reducers: {
        fetchStateOption: (state, action) => {
            state.getState = action.payload
            state.isLoading = false
        },
        fetchStateOptionError: (state, action) => {
            state.isLoading = false
            state.isError = true
            state.error = action?.payload?.response?.data?.message
        }
    },
});

export const { fetchStateOption, fetchStateOptionError } = contactFilterSlice.actions;
export default contactFilterSlice.reducer;